export const APP_SERVER_CONFIG = Object.freeze({
  origin: 'https://pc119mobile.unit.ne.jp:28899',
  socketNamespace: '/app',
  appToken: '3770df37-f71d-4c1e-abbb-f3fb30156751',
});

export const APP_SOCKET_URL = `${APP_SERVER_CONFIG.origin}${APP_SERVER_CONFIG.socketNamespace}`;
export const APP_API_BASE_URL = `${APP_SERVER_CONFIG.origin}/api`;
export const PDF_RENDER_API_URL = `${APP_SERVER_CONFIG.origin}/api/pdf/render`;
